import { EntitySidebarTile, EntitySidebarTileProps } from "./EntitySidebarTile/EntitySidebarTile";
import { NotSet } from "../../misc/UIconstants";
import {
  CustomFieldTemplate,
  customFieldTemplateConstants,
  CustomFieldTemplateFilters,
  CustomFieldTemplateFiltersTranslator,
  CustomFieldTemplateSortingOptionsConsts,
} from "../../../api/CustomFields/CustomFieldTemplates";
import { useMemo } from "react";
import { generateAbstractedFromDataType } from "../../../Customization/CustomFields/CustomFieldUtils";
import { AbstractedCustomFieldDataTypeIcon } from "../../../Customization/CustomFields/CustomFieldRenderUtils";
import { LucideIcon } from "../../icon/LucideIcon";
import { defaultCustomFieldTemplatesFilters } from "../../../Customization/CustomFieldTemplates/Table/CustomFieldTemplatesTable";

export const CustomFieldTemplateTile = (
  props: EntitySidebarTileProps<CustomFieldTemplate, CustomFieldTemplateFilters>
) => {
  const defaultFilters: CustomFieldTemplateFilters = useMemo(
    () => ({ ...defaultCustomFieldTemplatesFilters, ...props.defaultFilters }),
    [props.defaultFilters]
  );
  return (
    <EntitySidebarTile<CustomFieldTemplate, CustomFieldTemplateFilters>
      rowId={(e) => `Version ${e.templateVersion}`}
      rowLabel={(e) => <>{e.name}</>}
      rowInfo={(e) => <span title={e.description}>{e.description ?? NotSet}</span>}
      rowDate={(e) => {
        const _type = generateAbstractedFromDataType(e.dataType);
        return (
          <div
            className="flex align-center gap-5"
            style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "12px" }}
          >
            {_type && (
              <div className="flex row-nowrap align-center gap-5">
                {_type.abstractedDataType && (
                  <>
                    <div>
                      <AbstractedCustomFieldDataTypeIcon dataType={_type.abstractedDataType} color="var(--secondary)" />
                    </div>
                    {_type.abstractedDataType}
                    {_type.isMulti && (
                      <label className="label label-soft-info" style={{ margin: 0 }}>
                        Multi
                      </label>
                    )}
                  </>
                )}
              </div>
            )}
            {e.required && (
              <div className="flex align-center gap-5">
                ,<LucideIcon name="asterisk" color="var(--danger)" /> Value required
              </div>
            )}
          </div>
        );
      }}
      {...props}
      entityConstants={customFieldTemplateConstants}
      orderByOptions={CustomFieldTemplateSortingOptionsConsts}
      translatorConsts={CustomFieldTemplateFiltersTranslator}
      defaultFilters={defaultFilters}
    />
  );
};
